import {lazy} from 'react';

import type {RouteConfig} from '../types';

import {Loadable} from '../components/Loadable';
import {SpinnerFallback} from '../components/SpinnerFallback';
import {profileRoutesPath} from './path';

const ProfilePage = Loadable(
  lazy(
    () => import('@src/pages/Profile' /* webpackChunkName: "profile-page" */),
  ),
);

// TABS
const InfoTab = Loadable(
  lazy(
    () =>
      import(
        '@src/modules/UserProfile/UserProfile' /* webpackChunkName: "profile-info-tab" */
      ),
  ),
  <SpinnerFallback />,
);
const CertificationTab = Loadable(
  lazy(
    () =>
      import(
        '@src/modules/UserCertification/UserCertification' /* webpackChunkName: "profile-certification-tab" */
      ),
  ),
  <SpinnerFallback />,
);
const SubscriptionTab = Loadable(
  lazy(() =>
    import(
      '@src/v2/modules/subscription' /* webpackChunkName: "profile-subscription-tab" */
    ).then(module => ({default: module.YcSubscription})),
  ),
  <SpinnerFallback />,
);
const SettingsTab = Loadable(
  lazy(() =>
    import(
      '@src/v2/modules/settings' /* webpackChunkName: "profile-settings-tab" */
    ).then(module => ({default: module.Settings})),
  ),
  <SpinnerFallback />,
);

export const profileRoutes = [
  {
    children: [
      {
        element: <InfoTab />,
        path: profileRoutesPath.info.$path(),
      },
      {
        element: <CertificationTab />,
        path: profileRoutesPath.certification.$path(),
      },
      {
        element: <SubscriptionTab />,
        path: profileRoutesPath.subscription.$path(),
      },
      {
        element: <SettingsTab />,
        path: profileRoutesPath.settings.$path(),
      },
    ],
    element: <ProfilePage />,
    path: profileRoutesPath.$path(),
  },
] satisfies RouteConfig[];
